import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {SupportSwitchButton} from './components';

import UserManualModal from 'components/UserManualModal/UserManualModal';

import UserManualLabel from 'pages/System/UserManual/UserManualLabel';
import {UserManualTypes, UserManualType} from 'pages/System/UserManual/types';

import {SupportSwitchLinkProps} from './types';

const isUserManualType = (type: string): type is UserManualType => {
    return (Object.values(UserManualTypes) as string[]).includes(type);
};

interface SupportSwitchInterface {
    isMobile: boolean;
    type: string;
    closeDrawer?: () => void;
}

const SupportSwitch: React.FC<SupportSwitchInterface> = ({isMobile, type, closeDrawer}) => {
    const [showManualModal, setShowManualModal] = useState<boolean>(false);

    const supportSwitchLinks: SupportSwitchLinkProps[] = [];

    if (isUserManualType(type)) {
        supportSwitchLinks.push({
            key: 'manual',
            className: 'with-accent',
            label: <UserManualLabel type={type}/>,
            action:  () => setShowManualModal(true)
        });
    } else {
        supportSwitchLinks.push({
            key: 'support',
            label: <FormattedMessage id='system.help'/>,
            url: '/support'
        });
    }

    return (
        <>
            <div className={isMobile ? 'session-switch-item-mobile' : 'session-switch-item'}>
                <SupportSwitchButton supportSwitchLink={supportSwitchLinks.at(0)} closeDrawer={closeDrawer} />
            </div>

            {isUserManualType(type) && (
                <UserManualModal open={showManualModal} onCancel={setShowManualModal} type={type} />
            )}
        </>

    );
};

export default SupportSwitch;
